import React, { useEffect } from 'react';
import { Box, Typography, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector, useDispatch } from 'react-redux';
import { selectToasts, removeToast } from '../../store/slices/notificationsSlice';

const SEVERITY_STYLES = {
  info:    { bg: '#eff6ff', border: '#bfdbfe', color: '#1e40af', icon: '💬' },
  success: { bg: '#f0fdf4', border: '#bbf7d0', color: '#166534', icon: '✅' },
  warning: { bg: '#fffbeb', border: '#fde68a', color: '#92400e', icon: '⚠️' },
  error:   { bg: '#fef2f2', border: '#fecaca', color: '#991b1b', icon: '❌' },
};

function ToastContainer() {
  const dispatch = useDispatch();
  const toasts = useSelector(selectToasts);

  // Auto-dismiss toasts after 6 seconds
  useEffect(() => {
    if (toasts.length === 0) return;
    const timers = toasts.map(t =>
      setTimeout(() => dispatch(removeToast(t.id)), 6000)
    );
    return () => timers.forEach(clearTimeout);
  }, [toasts, dispatch]);

  if (toasts.length === 0) return null;

  return (
    <Box style={{
      position: 'fixed', bottom: 16, right: 16, zIndex: 9999,
      display: 'flex', flexDirection: 'column-reverse', gap: 8,
      maxWidth: 420,
    }}>
      {toasts.slice(-5).map(toast => {
        const s = SEVERITY_STYLES[toast.severity] || SEVERITY_STYLES.info;
        return (
          <Box
            key={toast.id}
            style={{
              display: 'flex', alignItems: 'flex-start', gap: 10,
              padding: '10px 14px', borderRadius: 10,
              background: s.bg, border: `1px solid ${s.border}`,
              boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
              animation: 'slideInRight 0.3s ease-out',
            }}
          >
            <span style={{ fontSize: '1rem', flexShrink: 0, marginTop: 1 }}>{s.icon}</span>
            <Box style={{ flex: 1, minWidth: 0 }}>
              <Typography style={{ fontSize: '0.75rem', fontWeight: 600, color: s.color, lineHeight: 1.3 }}>
                {toast.message}
              </Typography>
              {toast.detail && (
                <Typography style={{ fontSize: '0.62rem', color: '#64748b', marginTop: 2 }}>
                  {toast.detail}
                </Typography>
              )}
            </Box>
            <IconButton size="small" onClick={() => dispatch(removeToast(toast.id))}
              style={{ padding: 2, color: '#94a3b8', marginTop: -2, marginRight: -4 }}>
              <CloseIcon style={{ fontSize: 14 }} />
            </IconButton>
          </Box>
        );
      })}
      <style>{`
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(60px); }
          to   { opacity: 1; transform: translateX(0); }
        }
      `}</style>
    </Box>
  );
}

export default ToastContainer;
